import React from 'react';
import ConfirmationModal from '../../../../components/modals/ConfirmationModal';

const ReturnLeadConfirmationModal = ({ isOpen, toggle, onConfirm, isLoading }) => {
    return (
        <ConfirmationModal
            isOpen={isOpen}
            toggleFn={toggle}
            title={'Confirm Returning Lead'}
            loadingState={isLoading}
            dimButtons
            actionFn={onConfirm} // The parent will provide the function that mutates and then toggles
        >
            <p style={{ fontWeight: '500', fontSize: '14px', color: 'red', marginBottom: '4px' }}>
                Your action cannot be undone once you return the leads.
            </p>
            <span>Are you sure you want to return this lead?</span>
        </ConfirmationModal>
    );
};

export default ReturnLeadConfirmationModal;